import { useState, useEffect } from "react";

import './ConfigDash.css';

import 'react-tooltip/dist/react-tooltip.css';
import { Tooltip } from 'react-tooltip';

import { SvgLink, SvgSave, SvgSetaDown, SvgSetaRight, SvgSetaUp } from "components/SvgFile";

import { GetDataPage, RegisterDataPage } from "interface/Data";
import { SetModalData, SetModalState } from "interface/PopUp";
import { Reg_AltPosition, Reg_EditConfig } from "services/RegisterData";

export default function Page_ConfigDash(){
    
    const [ loading, setLoading ]   = useState(false);
    const [ dataPage, setDataPage ] = useState(GetDataPage('dataConfig'));

    const [ idiomaEn, setIdiomaEn ]     = useState(dataPage[0]['en']);
    const [ idiomaEs, setIdiomaEs ]     = useState(dataPage[0]['es']);
    const [ idiomaPtBr, setIdiomaPtBr ] = useState(dataPage[0]['pt_br']);

    const [ linkWhatsapp, setLinkWhatsapp ] = useState(dataPage[0]['link_whatsapp']);

    const [ listName, setListName ] = useState(InitialData());

    function InitialData(){
        const newData = dataPage.filter(item => item.type == 'menu');
        return newData;
    }

    function SaveData(event){
        event.preventDefault();
        setLoading(true);
        Reg_EditConfig(idiomaEn, idiomaEs, idiomaPtBr, listName, linkWhatsapp, ()=>{ CallbackSuccess() }, ()=>{ CallbackError() });
    }

    function ChangePosition(id, order, type){
        Reg_AltPosition('dataConfig', id, order, type, ()=>{ }, ()=>{ CallbackError() });
    }

    function CallbackSuccess(){
        setLoading(false);
        SetModalData('ReturnResponse', { "page": "ok" });
        SetModalState('ReturnResponse', true);
    }

    function CallbackError(){
        setLoading(false);
        SetModalData('ReturnResponse', { "page": "erro" });
        SetModalState('ReturnResponse', true);
    }

    function HandleInput(type, index, value){
        const newData = [...listName];
        newData[index][type] = value;
        setListName(newData);
    }

    useEffect(()=>{
        RegisterDataPage('dataConfig', setDataPage);
    }, []);

    useEffect(()=>{
        setDataPage(GetDataPage('dataConfig'));
        
        setIdiomaEn(dataPage[0]['en']);
        setIdiomaEs(dataPage[0]['es']);
        setIdiomaPtBr(dataPage[0]['pt_br']);

        setLinkWhatsapp(dataPage[0]['link_whatsapp']);

        setListName(InitialData());
    }, [dataPage]);

    return(
        <div className="Page_ConfigDash">
            <div className={ loading == true ? "return_data_save div_loading" : "return_data_save" }>
                <img alt="loading" src="./assets/loading.gif" className="loading" />
            </div>
            <form onSubmit={ SaveData }>
                <div className="new_block">
                    <div className="div_name_page">
                        <div className="name_fixed">
                            Dashboard
                        </div>
                        <div className="show_icon">
                            <SvgSetaRight color="#CDD1D6" className="icons" />
                        </div>
                        <div className="name_page">
                            Configurações
                        </div>
                    </div>
                    <div className="list_opt_alt_page">
                        <button className="new_block_text">
                            <div className="">
                                <SvgSave color="#ffffff" className="icons" />
                            </div>
                            <div className="">Salvar</div>
                        </button>
                    </div>
                </div>

                <div className="">
                    <div className="show_page_data"> 
                        <div className="list_type_data">
                            <div className="type_title">Link do whatsapp</div>
                        </div>
                        <div className="list_opt_idioma">
                            <div className="div_input space_div">
                                <input type="text" onChange={ (e)=>{ setLinkWhatsapp(e.target.value) } } value={ linkWhatsapp } />
                            </div>
                            {
                                linkWhatsapp == '' ? null :
                                <div className="div_input">
                                    <a href={ linkWhatsapp } target="_blank">
                                        <SvgLink className="icons" color="#324d6b" />
                                    </a>
                                </div>
                            }
                        </div>
                    </div>

                    <div className="show_page_data"> 
                        <div className="list_type_data">
                            <div className="type_title">Idiomas ativo no site</div>
                        </div>
                        <div className="list_opt_idioma">
                            <div className={ idiomaPtBr == true ? "div_idioma idioma_active" : "div_idioma" } onClick={ ()=>{ setIdiomaPtBr(!idiomaPtBr) } }>Português</div>
                            <div className={ idiomaEn == true ? "div_idioma idioma_active" : "div_idioma" } onClick={ ()=>{ setIdiomaEn(!idiomaEn) } }>Inglês</div>
                            <div className={ idiomaEs == true ? "div_idioma idioma_active" : "div_idioma" } onClick={ ()=>{ setIdiomaEs(!idiomaEs) } }>Espanhol</div>
                        </div>
                    </div>

                    <div className="show_page_data"> 
                        <div className="list_type_data">
                            <div className="type_title">Nomes do menu</div>
                        </div>
                        <table cellPadding="0" cellSpacing="0">
                            <thead>
                                <tr>
                                    <th width="20" align="center">#</th>
                                    <th>Português</th>
                                    <th>Inglês</th>
                                    <th>Espanhol</th>
                                    <th width="60">Order</th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    listName.map((key, index)=>{
                                        return(
                                            <tr key={ index }>
                                                <td align="center">{ index + 1 }</td>
                                                <td>
                                                    <input type="text" className="input_table" onChange={ (e)=>{ HandleInput('pt_br', index, e.target.value); } } value={ key.pt_br } />
                                                </td>
                                                <td>
                                                    <input type="text" className="input_table" onChange={ (e)=>{ HandleInput('en', index, e.target.value); } } value={ key.en } />
                                                </td>
                                                <td>
                                                    <input type="text" className="input_table" onChange={ (e)=>{ HandleInput('es', index, e.target.value); } } value={ key.es } />
                                                </td>
                                                <td align="right">
                                                    <div className="div_opt_alt">
                                                        {
                                                            index == 0 ?
                                                            <div className="space_div_icon" /> :
                                                            <div data-tooltip-id={ "position_" + key.id } data-tooltip-content="Alterar posição" data-tooltip-place="top" className="space_div_icon" onClick={ ()=>{ ChangePosition(key.id, key.order_, 'up') } }>
                                                                <SvgSetaUp color="#324d6b" className="icons"/>
                                                            </div>
                                                        }
                                                        {
                                                            (index + 1) == listName.length ?
                                                            <div className="space_div_icon" /> :
                                                            <div data-tooltip-id={ "position_" + key.id } data-tooltip-content="Alterar posição" data-tooltip-place="top" className="space_div_icon" onClick={ ()=>{ ChangePosition(key.id, key.order_, 'down') } }>
                                                                <SvgSetaDown color="#324d6b" className="icons"/>
                                                            </div>
                                                        }
                                                        <Tooltip id={ "position_" + key.id } />
                                                    </div>
                                                </td>
                                            </tr>
                                        )
                                    })
                                }
                            </tbody>
                        </table>
                    </div>
                </div>
            </form>
        </div>
    );
}